// Who may see and fill in which parts of a checklist. Mirrors
// API/services/checklistAccess.js, which is what actually enforces it; this
// copy decides what to show.
//
//   - Admins, managers and buyers oversee: they see and can fill in everything.
//   - A section with its own assignees can only be filled in by them.
//   - Otherwise a section belongs to the checklist's assignees.
//   - A checklist with no assignees is open to everyone at the site.

export const OVERSIGHT_TYPES = ['admin', 'manager', 'buyer'];

export const isOversight = user => Boolean(user && OVERSIGHT_TYPES.includes(user.type));

export const assigneeIds = list =>
  (Array.isArray(list) ? list : []).map(a => String((a && a.id) || a || '')).filter(Boolean);

// The people a section belongs to: its own, else the checklist's.
export const sectionOwnerList = (checklist, section) => {
  const own = (section && section.assignees) || [];
  return own.length ? own : (checklist && checklist.assignees) || [];
};

export const canFillSection = (checklist, section, user) => {
  if (isOversight(user)) return true;
  const owners = assigneeIds(sectionOwnerList(checklist, section));
  return !owners.length || owners.includes(String(user && (user.id || user._id)));
};

// "Peter, Mary" — or '' when it's open to everyone.
export const assigneeNames = list =>
  (Array.isArray(list) ? list : [])
    .map(a => (a && a.name) || '')
    .filter(Boolean)
    .join(', ');

// Everyone named anywhere on a checklist, for the card summary.
export const everyoneAssigned = checklist => {
  const seen = new Map();
  [checklist && checklist.assignees, ...((checklist && checklist.sections) || []).map(s => s.assignees)]
    .forEach(list =>
      (list || []).forEach(a => {
        if (a && a.id && !seen.has(a.id)) seen.set(a.id, a);
      })
    );
  return Array.from(seen.values());
};
